import { render, staticRenderFns } from "./AppointmentsWaitModal.vue?vue&type=template&id=52c41642&scoped=true&"
import script from "./AppointmentsWaitModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentsWaitModal.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsWaitModal.vue?vue&type=style&index=0&id=52c41642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c41642",
  null
  
)

export default component.exports